module.exports = __webpack_public_path__ + "img/nbanner.58a70e20.png";